import { Injector } from '@angular/core';
import { AuthenticationMethod, EndpointRedirectRequestStrategy } from '@technocom/auth';
import { HrefService } from '@technocom/common';

export function LogoutMethodInitializer(injector: Injector): AuthenticationMethod {
  return AuthenticationMethod.of({
    id: 'logout',
    icon: 'fas fa-sign-out-alt',
    endpoint: () => injector.get(HrefService).apiTo('/logout'),
    external: true,
    request: EndpointRedirectRequestStrategy,
    button: {
      text: 'Выход',
    },
    action: {
      text: 'Выйти',
    },
  });
}
